/* @jsxImportSource react */

import type { PropsWithChildren } from 'react';
import { Button } from '@packages/shared/src/ui/Button/Button';
import { boxShadowClass } from './shared';

export type TileButtonProps = PropsWithChildren & {
  /* 
    is the tile an active tile
  */
  mode: 'selected' | 'disabled' | 'disabledAndSelected';
};
/* 
  The TileButton component is a common Button but is extended with loading indicator
  which is visible while the new variation is loading its data
*/
export const TileButton = ({ mode, children }: TileButtonProps) => {
  switch (mode) {
    case 'disabled':
    case 'disabledAndSelected': {
      return (
        <Button
          disabled
          className={`text-color-text-darktransparent bg-color-background-base opacity-100! ${mode === 'disabledAndSelected' ? 'border-color-text-dark border-2' : 'border-color-grey'}`}
        >
          {children}
        </Button>
      );
    }
    case 'selected':
    default:
      return (
        <Button
          disabled
          className={`text-color-text-dark border-color-text-dark border-2 opacity-100! shadow-xs ${boxShadowClass}`}
        >
          {children}
        </Button>
      );
  }
};
